/* This file is autogenerated, see readme.md for instructions */
import InfoFilledSvgIcon from '@bloomreach/banana-theme/icons/info-filled.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const InfoFilledIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <InfoFilledSvgIcon />
    </Icon>
  );
});

InfoFilledIcon.displayName = 'InfoFilledIcon';

export default InfoFilledIcon;
